"use strict";
/*
 * Created on 06 17 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var DashboardTaskConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DashboardTaskConverter, _DataObjectConverter_);

  function DashboardTaskConverter() {
    _classCallCheck(this, DashboardTaskConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DashboardTaskConverter).apply(this, arguments));
  }

  return DashboardTaskConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DashboardTaskConverter = DashboardTaskConverter;